import * as React from 'react';
import classnames from 'classnames';
import Tooltip from "../Tooltip";
import Loader from "../Loader";
import Icon, { IconType } from "../Icon";
import style from './Button.scss';
import { AvailableColors } from "../../interfaces/models";

export enum BUTTON_ICON_POSITION {
  BEFORE,
  AFTER
}

//React.ButtonHTMLAttributes<HTMLButtonElement | HTMLLinkElement> &
export type Props = {
  className?: string,
  tag?: 'a' | 'button' | React.FunctionComponent,
  icon?: IconType,
  iconPosition?: BUTTON_ICON_POSITION,
  size?: 'sm' | 'md' | 'lg',
  outline?: boolean,
  block?: boolean,
  cta?: boolean,
  bg?: boolean,
  color?: AvailableColors,
  children?: React.ReactNode,
  loading?: boolean,
  [buttonProps: string]: any,
  tooltip?: string,
};

const renderIcon = (icon: IconType, iconPosition: BUTTON_ICON_POSITION, position: BUTTON_ICON_POSITION) => {
  if (!icon || iconPosition !== position) return null;
  return <Icon icon={icon} className={style.icon} />;
}

const Button: React.ForwardRefExoticComponent<Props> = React.forwardRef<any, Props>((props, ref) => {
  let {
    tag,
    icon,
    iconPosition,
    size,
    outline,
    block,
    cta,
    bg,
    color,
    className,
    children,
    loading,
    tooltip,
    ...buttonProps
  } = props;
  const Tag: React.ElementType = tag || 'button';
  const onlyIcon = icon && !children;
  if (icon && !iconPosition) iconPosition = BUTTON_ICON_POSITION.BEFORE;

  const buttonClassName = classnames(
    style.container,
    onlyIcon && style.onlyIcon,
    iconPosition === BUTTON_ICON_POSITION.BEFORE && style.iconBefore,
    iconPosition === BUTTON_ICON_POSITION.AFTER && style.iconAfter,
    size && style[`size-${size}`],
    color ? style[`color-${color}`] : style['color-primary'],
    outline && style.outline,
    block && style.block,
    cta && style.cta,
    bg && style.bg,
    !buttonProps.disabled && className,
  );


  let element = (
    <Tag ref={ref} className={buttonClassName}{...buttonProps} disabled={buttonProps.disabled || loading}>
      {renderIcon(icon, iconPosition, BUTTON_ICON_POSITION.BEFORE)}
      {children && <span className={style.text}>{children}</span>}
      {renderIcon(icon, iconPosition, BUTTON_ICON_POSITION.AFTER)}
      {loading && <span className={style.loading}><Loader size={20} /></span>}
    </Tag>
  );

  if (tooltip) {
    // Для отключенных кнопок не срабатывает ховер и не появляется tooltip
    if (!!buttonProps.disabled) element =
      <span className={classnames(style.tooltipContainer, className)}>{element}</span>;
    element = <Tooltip content={tooltip}>{element}</Tooltip>;
  }

  return element;
});

Button.displayName = 'Button';

export default Button;
